import { guardExist as a, guardEmptyString as i } from "@smh/utils/guards";
const l = /^(http(s)?|ftp):\/\//, o = (t) => a(l.exec(t)), m = (t, r) => {
  if (!o(t))
    return !1;
  let e = !1;
  r = `https://${r}/`;
  const s = new URL(r).hostname.replace("www.", "").split(".").reverse(), n = new URL(t).hostname.replace("www.", "").split(".").reverse();
  return n <= s || s.forEach((c, u) => e = c === n[u]), e;
}, w = (t) => o(t) ? "_blank" : "_self", p = (t, r = "?") => {
  const e = Object.entries(t).filter((n) => a(n[1])), s = new URLSearchParams(e).toString();
  return `${r}${s}`;
}, h = (t, r) => {
  const e = new URL(t, "http://0.0.0.0"), s = i(e.search) ? "&" : "?";
  return `${t}${p(r, s)}`;
}, g = (t, r) => new URLSearchParams(t).get(r), S = (t) => {
  const { query: r, param: e, value: s } = t, n = g(r, e);
  return a(n) && n === s;
};
export {
  l as URL_REGEX,
  h as addQueryString,
  w as getLinkTarget,
  g as getQueryParamValue,
  S as hasQueryParamExists,
  o as isAbsoluteUrl,
  m as isSubdomainOfDomain,
  p as toQueryString
};
